export default __webpack_public_path__ + "static/media/theme-pastel.1777f782.png";